export default {
    /**
     * 数组删除元素
     * @param {*} arr 
     * @param {*} key  匹配key
     * @param {*} equalValue   需要删除的值
     */
    delArray(arr,key,equalValue)
    {
        arr.splice(arr.findIndex(item => item[key] === equalValue), 1)
    },
   
    findArryValue(arr,key,findValue)
    {
        
        return arr.find(item =>  item[key] == findValue)
    }
   
   }